<div class="card" *blockUI="'section-block'">
    <div class="row mb-1">
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-start align-items-center">
                <button class="btn btn-success" rippleEffect (click)="createPersonLeave()">
                    <i data-feather="plus" class="d-sm-none d-inline-block"></i><span
                        class="d-none d-sm-inline-block">İzin Ekle</span>
                </button>
            </div>
        </div>

        <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div class="d-flex justify-content-between align-items-center ">
                <label class="d-flex align-items-center">
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
        </div>
    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true">

        <ngx-datatable-column name="Gün" prop="leaveDay"></ngx-datatable-column>

        <ngx-datatable-column name="İzin Türü" prop="typeName"></ngx-datatable-column>

        <ngx-datatable-column name="İzin Tarihleri">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.startDate | date:'dd.MM.yyyy'}} - {{row.endDate | date:'dd.MM.yyyy'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Durum">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div [ngClass]="getBadgeClass(row.status)">{{getStatusText(row.status)}}</div>

            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                    <button appDelete controller="PersonLeaves" [id]="row.id"
                        (callback)="getAllWorkerLeave(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId)"
                        class="btn btn-icon btn-flat-danger">
                        <span [data-feather]="'trash'"></span>
                    </button>
                    <button class="btn btn-icon btn-flat-warning" (click)="updatePersonLeave(row)">
                        <span [data-feather]="'edit'"></span>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>

                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>

            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>